import { render } from "./PanelsDemo.vue?vue&type=template&id=15306e16&scoped=true"
import script from "./PanelsDemo.vue?vue&type=script&lang=js"
export * from "./PanelsDemo.vue?vue&type=script&lang=js"

import "./PanelsDemo.vue?vue&type=style&index=0&id=15306e16&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15306e16"]])

export default __exports__